import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import MutasiVoucherPdf from "./pdf/MutasiVoucher";

function MutasiVoucherComponent() {
  const { bulan, api } = useGlobalContext();

  const Tahunaktif = new Date().getFullYear();

  const tahunterakhir = Array.from(
    { length: 3 },
    (_, i) => Tahunaktif - i
  );

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(
    tahunterakhir[0]
  );

  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleBulanChange = (e) => {
    setSelectedBulan(parseInt(e.target.value, 10));
  };

  const handleTahunChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleSubmit = async () => {
    const bulanNumber = (selectedBulan + 1)
      .toString()
      .padStart(2, "0");

    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan =
      bulan[selectedBulan] || "Tidak Diketahui";

    const tahun = selectedYear;

    setLoading(true);

    try {
      const response = await api.get(
        `/api/laporan/mutasivoucher/${periode}`
      );

      const result = response.data;

      if (
        !Array.isArray(result.data) ||
        result.data.length === 0
      ) {
        alert(
          `Data tidak ditemukan untuk periode ${namaBulan} ${tahun}.`
        );
      } else {
        MutasiVoucherPdf(
          result.data,
          namaBulan,
          tahun,
          periode
        );
      }
    } catch (error) {
      console.error(
        "Gagal mengambil data:",
        error
      );

      alert(
        `Terjadi kesalahan saat mengambil data: ${
          error.response?.status || error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

 const handleExportExcel = async () => {
  let bulanNumber = (selectedBulan + 1)
    .toString()
    .padStart(2, "0");

  let periode = `${selectedYear}${bulanNumber}`;
  let namaBulan =
    bulan[selectedBulan] || "Tidak Diketahui";
  let tahun = selectedYear;

  setIsExporting(true);

  try {

    const response = await api.get(
      `/api/exsportexcell/mutasivoucher/${periode}`,
      {
        responseType: "blob",        
      }
    );

    const filename = `Mutasi_Voucher_${namaBulan}_${tahun}.xlsx`;

    const blob = new Blob(
      [response.data],
      {
        type:
          response.headers["content-type"],
      }
    );

    const url =
      window.URL.createObjectURL(blob);

    const a =
      document.createElement("a");

    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(
      "Export Excel error:",
      err
    );

    alert(
      `Gagal export Excel : ${
        err.response?.status ||
        err.message
      }`
    );
  } finally {
    setIsExporting(false);
  }
};

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="row">
          <div className="col-md-12">
            <div
              className="card card-info"
              style={{ width: "400px" }}
            >
              <div className="card-header">
                <h5 className="card-title">
                  Laporan Mutasi Voucher
                </h5>
              </div>

              <div className="card-body">
                <form className="form-horizontal">
                  <div className="form-group row mb-1">
                    <label
                      htmlFor="bulan"
                      className="col-sm-3 col-form-label"
                    >
                      Periode
                    </label>

                    <div
                      className="col-sm-6"
                      style={{ flex: 1 }}
                    >
                      <select
                        className="form-control"
                        name="bulan"
                        value={selectedBulan}
                        onChange={handleBulanChange}
                      >
                        {bulan.map((item, index) => (
                          <option
                            key={index}
                            value={index}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="col-sm-4"
                      style={{ flex: 1 }}
                    >
                      <select
                        className="form-control"
                        name="tahun"
                        value={selectedYear}
                        onChange={handleTahunChange}
                      >
                        {tahunterakhir.map((year) => (
                          <option
                            key={year}
                            value={year}
                          >
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer mb-0 mt-0">
                <button
                  type="button"
                  className="btn btn-sm btn-primary mr-2"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading
                    ? "Mengambil Data..."
                    : "Cetak"}
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleExportExcel}
                  disabled={isExporting}
                >
                  {isExporting
                    ? "Mengekspor..."
                    : "Export Excel"}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiVoucherComponent;